import { render, staticRenderFns } from "./QuestionPageHeader.vue?vue&type=template&id=243e6673&"
import script from "./QuestionPageHeader.vue?vue&type=script&lang=js&"
export * from "./QuestionPageHeader.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPageHeader.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VDivider})
